import { lazy } from 'react';
import type React from 'react';
import { reloadPage } from './reloadPage';

export function isChunkError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }

  if (error.name === 'ChunkLoadError') {
    return true;
  }

  if (/Loading chunk \d+ failed/.test(error.message)) {
    return true;
  }

  if (/Loading CSS chunk \d+ failed/.test(error.message)) {
    return true;
  }

  if (error.message.includes('Failed to fetch dynamically imported module')) {
    return true;
  }

  return false;
}

export function lazyWithRetry<T extends React.ComponentType<never>>(
  importFn: () => Promise<{ default: T }>
): React.LazyExoticComponent<T> {
  return lazy((): Promise<{ default: T }> => {
    return importFn().catch((error: unknown) => {
      if (!isChunkError(error)) {
        throw error;
      }

      if (sessionStorage.getItem('chunk_reload_attempted')) {
        throw error;
      }

      sessionStorage.setItem('chunk_reload_attempted', 'true');
      reloadPage();

      // Page is reloading — return a never-resolving promise
      return new Promise<{ default: T }>(() => {});
    });
  });
}
